import { useEffect, useRef, useState } from 'react';

import DropdownArrowIcon from '@/assets/all-icons/dropdown-arrow-icon';
import useTranslations from '@/i18n/useTranslations';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import PublicSuccessCheck from '@/shared-components/icons/components/public/PublicSuccessCheck';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/StepAccordeon.css';

export default function StepAccordeon({ lastCompletedStep, step, header, previewMode, editMode, locked = false, activeClassName="step-accordeon__content-active-default", validationFocus = null, children }) {
  const t = useTranslations('common.forms.add_artwork');
  const [active, setActive] = useState(editMode === true || previewMode === true || lastCompletedStep + 1 === step || lastCompletedStep >= 3); 
  const containerRef = useRef(null);
  // Step completion no longer controls access to another section. `locked` is
  // reserved for account-specific restrictions, such as artist shipping.
  const disabled = locked;

  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  useEffect(()=>{
    setActive(editMode === true || previewMode === true || lastCompletedStep + 1 === step || lastCompletedStep >= 3);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [lastCompletedStep]);

  useEffect(() => {
    if (validationFocus?.step !== step) return;

    setActive(true);

    requestAnimationFrame(() => {
      containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [step, validationFocus]);

  return (
    <>
      <div ref={containerRef} className={`step-accordeon__container${active ? " active" : ""}${disabled ? " disabled" : ""}${step === 3 ? " no-border" : ""}`}>
        <div className="step-accordeon__step-header" onClick={()=>{if(!disabled) setActive(!active);}}>
          <div className="step-accordeon-step-header__text-container">
            <Text className="step-accordeon-step-header__text" paragraph>{t('step', { step, total: 3 })}</Text>
            <h2 className="step-accordeon-step-header__heading">
              <Heading className="step-accordeon-step-header__heading-text">{header}</Heading>
              {step === 3 && (
                <InfoIconArtwork
                  className="step-accordeon-step-header__info-icon non-selectable-info-icon"
                  onClick={(status) => setIsInfoIconOpen(status)}
                  open={isInfoIconOpen}
                  header={t('sections.shipping')}
                  description={t('shipping_info')}
                />
              )}
            </h2>
          </div>

          {(editMode===false && (previewMode === true || step <= lastCompletedStep)) && (<PublicSuccessCheck className="step-accordeon-step-header__completed-icon"/>)}
          <DropdownArrowIcon className="step-accordeon-step-header__icon"/>
        </div>

        <div className={`step-accordeon__content ${active ? activeClassName : ""}`}>
          {children}
        </div>
      </div>
    </>
  );
}
